import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Button from "material-ui/Button";
import Card, { CardActions, CardContent } from "material-ui/Card";
import { withStyles } from "material-ui/styles";

import SurveyTable from "components/SurveyTable";
// Utils
import history from "utils/history";
import { setCreateSurveyCustomerId } from "redux/modules/createSurvey";

const styles = {
  card: {
    marginTop: 30
  },
  title: {
    flex: 1
  },
  cardActionsRoot: {
    padding: 12
  }
};

const CustomerDetailSurveyTable = props => {
  const { classes, surveys, historyPush, setCustomerId } = props;

  return (
    <Card className={classes.card}>
      <CardActions classes={{ root: classes.cardActionsRoot }}>
        <h4 className={classes.title}>アンケート一覧</h4>

        <Button
          raised
          onClick={() => {
            const { id } = props.match.params;
            setCustomerId(id);
            historyPush(`/create_survey/${id}/base_info`);
          }}
        >
          アンケート作成
        </Button>
      </CardActions>

      <CardContent>
        <SurveyTable surveys={surveys} historyPush={historyPush} />
      </CardContent>
    </Card>
  );
};

const mapStateToProps = state => ({
  surveys: state.customerDetail.surveyTable.surveys
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  historyPush: path => history.push(path, ownProps),
  setCustomerId: () => {
    const { id } = ownProps.match.params;
    dispatch(setCreateSurveyCustomerId(id));
  }
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(
    withStyles(styles)(CustomerDetailSurveyTable)
  )
);



// WEBPACK FOOTER //
// ./src/containers/CustomerDetail/SurveyTableContainer.js